import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const RECEPTION_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.RECEPTION,
  false
);

export const receptionApi = {
  receptionForm: () => apiClient.get(`${RECEPTION_BASE}/form`),

  editReceptionForm: Id =>
    apiClient.get(`${RECEPTION_BASE}/form?is_edit=true&reception_id=${Id}`),

  createReception: combinedData =>
    apiClient.post(`${RECEPTION_BASE}`, combinedData),

  updateReception: (reception_id, combinedData) =>
    apiClient.put(`${RECEPTION_BASE}/${reception_id}`, combinedData)
};
